import { render, staticRenderFns } from "./EmailLoginForm.vue?vue&type=template&id=756a2c70&scoped=true&"
import script from "./EmailLoginForm.vue?vue&type=script&lang=js&"
export * from "./EmailLoginForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "756a2c70",
  null
  
)

export default component.exports